import React from 'react';
const Refunds = () => <div className="p-8"><h1 className="text-2xl font-bold">Refunds Page</h1></div>;
export default Refunds; 